type GeodataUsageLike = {
  buildingsEnabled?: unknown;
  treesEnabled?: unknown;
  hasBuilding?: unknown;
  hasBuildings?: unknown;
  hasVegetation?: unknown;
  hasTrees?: unknown;
  building?: unknown;
  vegetation?: unknown;
};

const parseBooleanFlag = (value: unknown, fallback = false): boolean => {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    if (value === '1' || value.toLowerCase() === 'true') return true;
    if (value === '0' || value.toLowerCase() === 'false') return false;
  }
  return Boolean(value);
};

export function getGeodataRequiredModuleCount(geodata: GeodataUsageLike | null | undefined): number {
  if (!geodata) {
    return 2;
  }

  const buildingsEnabled = parseBooleanFlag(
    geodata.buildingsEnabled ?? geodata.hasBuilding ?? geodata.hasBuildings ?? geodata.building,
    false
  );
  const treesEnabled = parseBooleanFlag(
    geodata.treesEnabled ?? geodata.hasVegetation ?? geodata.hasTrees ?? geodata.vegetation,
    false
  );

  return 2 + Number(buildingsEnabled) + Number(treesEnabled);
}

export function getGeodataModuleLimitMessage(remainingCount: number | null, requiredCount: number): string {
  if (remainingCount === null) {
    return '';
  }

  if (remainingCount <= 0) {
    return 'No geodata modules are available on this project.';
  }

  if (requiredCount > remainingCount) {
    return `This geodata requires ${requiredCount} modules, but only ${remainingCount} ${remainingCount === 1 ? 'is' : 'are'} available on this project.`;
  }

  return '';
}
